// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"880":"ad1d5351","973":"ccf3380e"}[chunkId] + ".chunk.css";
};